import React, { useEffect, useState } from "react";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import IconShow from "canvas-core-react/lib/IconShow";
import { ReactTitle } from "react-meta-tags";
import { useTranslation } from "react-i18next";

import {
  errorContainer,
  loadingHtml,
  sucessInfoModal,
  getFilters as customSearch,
} from "../../../utils/functions";
import BillDetails from "../../billDetails";
import Modal from "../../../utils/customModal";
import TableAdmissions from "../../../shared/admissions/table";
import noAproval from "../../../../../static/images/add-client-bsc.svg";
import useApi from "../../../hooks/useApi";

const Bills = ({ setFilters }) => {
  const [{ data, page, totalSize, ready }, setState] = useState({
    page: 0,
    data: [],
    totalSize: 0,
    ready: false,
  });

  const [modal, setModal] = useState(defaultModal);
  const [menu, setMenu] = useState(null);
  const [billSelected, setBillSelected] = useState(null);

  const { getApiCAll, postApiCAll } = useApi();
  const { t } = useTranslation();

  const { pageTitle, headers, buttons, labels } = {
    pageTitle: t("admissions.tabs.bills"),
    headers: t("general.headers", { returnObjects: true }),
    buttons: t("general.buttons", { returnObjects: true }),
    labels: t("general.labels", { returnObjects: true }),
  };

  const getData = async ({ page, sizePerPage = 10, customFilters = [] }) => {
    try {
      setModal({ show: true, content: loadingHtml() });
      setState((prev) => ({ ...prev, ready: false }));
      const { data } = await getApiCAll(
        "/parameters/bills/admission",
        undefined,
        { page, size: sizePerPage, search: customSearch(customFilters) }
      );

      setState({
        data:
          data?.data?.content?.map(({ billWrapper }) => ({
            ...billWrapper,
            statusRef: t(
              `general.billStates.${billWrapper.statusContingency}`
            ),
            modification: formatDate(billWrapper.updateContingency),
          })) || [],
        page,
        totalSize: data?.data?.totalElements || 0,
        ready: true,
      });
      closeModal();
    } catch (err) {
      setErrorMessage(err.response?.data?.notifications[0]?.description);
    }
  };

  const handleMenus = (id) => setMenu(id === menu ? null : id);

  const getTableColumns = () => {
    return [
      { grow: 2, selector: "company.companyName", name: headers.clientName },
      { grow: 2, selector: "company.cif", name: headers.cif },
      { grow: 2, selector: "billNumber", name: headers.bill },
      { grow: 2, selector: "provider.companyName", name: headers.providerName },
      { grow: 2, selector: "provider.businessId", name: headers.providerId },
      { grow: 2, selector: "totalAmount", name: headers.amount },
      { grow: 2, selector: "modification", name: headers.modification },
      { grow: 2, selector: "statusRef", name: headers.state },
      {
        grow: 2,
        selector: "actions",
        name: headers.actions,
        center: true,
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menu === row.id}
            setIsMenuOpen={() => handleMenus(row.id)}
          >
            <ActionMenuListItem
              icon={() => (
                <IconShow
                  id={`bill-approval-${row.id}`}
                  className="TextButton__icon--left"
                />
              )}
              onClick={() => {
                setMenu(null);
                setTimeout(() => setBillSelected(row), 100);
              }}
            >
              {t("detail")}
            </ActionMenuListItem>
          </ActionMenuList>
        ),
      },
    ];
  };

  const closeModal = () => setModal(defaultModal);

  const setErrorMessage = (message) => {
    setModal({
      show: true,
      content: errorContainer("Error", message, {
        continueBtn: {
          text: buttons.continue,
          action: closeModal,
        },
      }),
    });
  };

  const goBack = () => {
    setBillSelected(null);
  };

  const handleSelect = (approve, items) => {
    handleSubmit(
      Object.keys(items).map((key) => ({
        idBill: key.split("-")[1],
        approve,
      }))
    );
  };

  const updateBill = (approve, idBill) => {
    handleSubmit([{ idBill, approve }]);
  };

  const handleSubmit = async (items) => {
    try {
      setModal({ show: true, content: loadingHtml() });

      const {
        data: {
          data: { details },
        },
      } = await postApiCAll("/parameters/bills/approve-or-rejected", items);

      if (details.length) return setErrorMessage(details[0]?.message);

      setModal({
        show: true,
        content: sucessInfoModal(pageTitle, t("general.modal.success"), {
          SelBtn: {
            text: buttons.continue,
            action: () => getData({ page: 0 }),
          },
        }),
      });
    } catch (err) {
      setErrorMessage(err.response?.data?.notifications[0]?.description);
    }
  };

  const getSearchResult = (property, value = "") => {
    let customFilters = [];

    if (value !== "") {
      // Realizamos la busqueda por filtros
      let operator = "";
      filters.map((item) => {
        if (item.property == property) {
          operator = item.operator;
        }
      });
      customFilters = [
        { property: property, operator: operator, value: value },
      ];
    }

    getData({
      page: 0,
      sizePerPage: 10,
      customFilters,
    });
  };

  const filters = getFilters(labels);

  useEffect(() => {
    setFilters({ filters, search: getSearchResult });
    getData({ page: 0 });

    return () => {
      setFilters({ filters: undefined, search: undefined });
    };
  }, []);

  return (
    <>
      <ReactTitle title={`${pageTitle} - Reverse Factoring`} />

      {ready &&
        (billSelected ? (
          <BillDetails
            data={billSelected}
            onSubmit={updateBill}
            goBack={goBack}
            admission
          />
        ) : data.length ? (
          <TableAdmissions
            headers={getTableColumns()}
            data={data}
            page={page}
            addmissionType="bills"
            sizePerPage={10}
            totalSize={totalSize}
            onTableChange={getData}
            submitAdmissions={handleSelect}
          />
        ) : (
          <div id="blankAprrovals">
            <img src={noAproval} className="clientImage" />
            <p>{t("admissions.noUserAdmissions")}.</p>
            <div className="line-aproval"></div>
          </div>
        ))}

      <Modal show={modal.show}>{modal.content}</Modal>
    </>
  );
};

export default Bills;

const defaultModal = { show: false, content: null };

const getFilters = ({ name }) => {
  return [
    {
      name,
      property: "company.institution.companyName",
      operator: "eq",
    },
    {
      name: "CIF",
      property: "company.institution.cif",
      operator: "eq",
    },
  ];
};

const formatDate = (value) => {
  if (!value) return null;

  const formatDate = new Date(value);

  return `${formatDate.toLocaleDateString()} - ${formatDate.toLocaleString(
    "en-US",
    {
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    }
  )}`;
};
